export default {
  namespaced: true,
  state: {
    messages: {},
    hasNewMessage: false
  },
  getters: {
    getByUserId: (state, getters) => id => {
      console.log("getter", id)
      if (_.isEmpty(state.messages) || id === null) return []
      if (!_.hasIn(state.messages, id)) return []

      return state.messages[id]
    },
    all: state => state.messages,
    getLatestMessages: (state, _getters, _rootState, rootGetters) => {
      if (_.isEmpty(state.messages)) return {}
      const myMessages = {}
      const authId = rootGetters["auth/id"]

      _.forEach(state.messages, (message, key) => {
        // 自分宛ての最終メッセージを一時変数に代入
        const latestMessage = _.findLast(message, dm => {
          return dm.toParticipantId === authId
        })

        if (!latestMessage) return

        // 一時変数にユーザー情報を追加
        latestMessage.participant = rootGetters["participants/getByUserId"](key)

        // ユーザーIDをkeyにして取得内容を代入
        myMessages[key] = latestMessage
      })

      return _(myMessages)
        .orderBy("createdAt", "desc")
        .reduce((result, latestMessage) => {
          result[latestMessage.fromParticipantId] = latestMessage
          return result
        }, {})
    },
    hasNewMessage: state => state.hasNewMessage
  },
  mutations: {
    init(state, messages) {
      state.messages = messages
    },
    addMessages(state, message) {
      const results = _.assign({}, state.messages)
      const to = message.getUnmatchedParticipantIdByAuthId(this.getters["auth/id"])

      if (_.hasIn(results, to)) {
        const index = _.findIndex(results[to], dm => {
          return dm.id === message.id
        })
        index === -1 ? results[to].push(message) : (results[to][index] = message)
      } else {
        results[to] = [message]
      }

      state.messages = results
      state.hasNewMessage = true
    },
    hasNewMessage(state, bool) {
      state.hasNewMessage = bool
    }
  },
  actions: {
    convertAll(state, socketIf) {
      const all = {}
      _(socketIf.body)
        .orderBy("createdAt", "asc")
        .forEach(message => {
          const to = message.getUnmatchedParticipantIdByAuthId(this.getters["auth/id"])
          if (_.hasIn(all, to)) {
            all[to].push(message)
          } else {
            all[to] = [message]
          }
        })

      state.commit("init", all)
    },
    setMessages(state, message) {
      console.log("dispatch")
      state.commit("addMessages", message)
    }
  }
}
